/**
 * 指挥端队员电话脱敏：11 位隐 4–7；6 位虚拟网隐中间 2 位。
 */
export function digitsOnly(phone) {
  return String(phone == null ? '' : phone).replace(/\D/g, '');
}

export function maskPhoneDigits(raw, revealed = false) {
  const d = digitsOnly(raw);
  if (!d) return '';
  if (revealed) return d;
  if (d.length === 11) return `${d.slice(0, 3)}****${d.slice(7)}`;
  if (d.length === 6) return `${d.slice(0, 2)}**${d.slice(4)}`;
  if (d.length <= 2) return '*'.repeat(d.length);
  const keep = Math.max(1, Math.floor(d.length / 3));
  return `${d.slice(0, keep)}${'*'.repeat(Math.max(2, d.length - keep * 2))}${d.slice(-keep)}`;
}

export function phoneHasMask(raw) {
  const masked = maskPhoneDigits(raw, false);
  return masked.includes('*');
}
